export function storeCategories( categories ) {
  return {
    type: 'STORE_CATEGORIES',
    categories
  };
};

